import { createClient } from '@assetsJsModule/client/recruitment';

const client = createClient();

export const applyToVacancy = (vacancyId, requestObject) => client.applyToVacancy(vacancyId, requestObject);
